// extracted by mini-css-extract-plugin
export var checkbox = "_98-0";
export var circle = "_98-3";
export var horizontalContainer = "_98-7";
export var sm = "_98-5";
export var switch0 = "_98-2";
export var switchDisabled = "_98-8";
export var switchEnabled = "_98-1";
export var textSwitchContainer = "_98-9";
export var textSwitchOption = "_98-a";
export var textSwitchOptionSelected = "_98-b";
export var verticalContainer = "_98-6";
export var xs = "_98-4";